export function getStringParam(param?: string | string[]) {
  return typeof param === 'string' ? param : param?.[0];
}
